<template>
  <div>
    <DigitalWorkshopComp v-bind:mobile="mobile"/>
    <RedirectActivitiesComp v-bind:mobile="mobile"/>
    <FollowUs v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import RedirectActivitiesComp from '@/components/desktop/Activities/RedirectActivitiesComp'
import DigitalWorkshopComp from "@/components/desktop/Activities/DigitalWorkshopComp";
import FollowUs from '@/components/desktop/FollowUs'

  export default {
    name: 'DigitalWorkshop',
    props: ['mobile'],
    components: {
      DigitalWorkshopComp,
      RedirectActivitiesComp,
      FollowUs
    },
  }
</script>
